export default class UpdateAttachmentRecordError extends Error {
}